// File upload — MIME type lists
export const ACCEPTED_IMAGE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/heic',
  'image/heif',
];

export const ACCEPTED_VIDEO_TYPES = [
  'video/quicktime',
  'video/mp4',
  'video/x-m4v',
  'video/mpeg',
];

// File size limits
export const MAX_SIZE_BYTES = 20 * 1024 * 1024; // 20 MiB
export const MAX_SIZE_MB = 20;

// Per-submission media limits
export const MAX_IMAGES = 5;
export const MAX_VIDEOS = 1;

// Customer contact preferences
export const PREFERRED_CONTACT_TIMES = ['Morning', 'Afternoon', 'Evening'];
export const PREFERRED_CONTACT_TIME_ZONES = [
  'Eastern',
  'Central',
  'Mountain',
  'Pacific',
];
